import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/faculty-members/FacultyDetailClient.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/styles/leadership.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@14.2.35_@playwright+test@1.62.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@14.2.35_@playwright+test@1.62.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
